<template>
  <div class="content ht-100v pd-0">
    <main-header txt="ЗХУТ төхөөрөмжид бүртгэгдсэн тээврийн хэрэгслийн тоо" />
    <div class="content-body pd-0-f" >
      <div class="container pd-0-f">
        <div class="card bd-0 bd-none" v-if="dashboardData.rdy">
            <div class="card-header d-flex justify-content-between">
              <h6 class="mg-b-0">Цагаар</h6>

              <div class="d-flex align-items-center text-center">
                  <div
                    class="profile-skillset flex-fill"
                  >
                    <h5>
                      <a class="link-01">{{ Number((dashboardData.data.list).reduce((sum, { count }) => sum + count, 0)).toLocaleString() }}</a>
                    </h5>
                    <label>Нийт</label>
                  </div>
                </div>

              <nav class="nav nav-row-xs align-items-center">
                <a
                  @click="
                    dashboardData.params.mode = 1;
                    loadVehicle();
                  "
                  :class="
                    `nav-link ${dashboardData.params.mode == 1 ? 'active' : ''}`
                  "
                  role="button"
                  >1D</a
                >
                <a
                  @click="
                    dashboardData.params.mode = 2;
                    loadVehicle();
                  "
                  :class="
                    `nav-link ${dashboardData.params.mode == 2 ? 'active' : ''}`
                  "
                  role="button"
                  >1W</a
                >
                <a
                  @click="
                    dashboardData.params.mode = 3;
                    loadVehicle();
                  "
                  :class="
                    `nav-link ${dashboardData.params.mode == 3 ? 'active' : ''}`
                  "
                  role="button"
                  >1M</a
                >
                <a
                  @click="
                    dashboardData.params.mode = 4;
                    loadVehicle();
                  "
                  :class="
                    `nav-link ${dashboardData.params.mode == 4 ? 'active' : ''}`
                  "
                  role="button"
                  >1Y</a
                >
              </nav>
            </div>
            <div class="card-body pd-0">
              <div>
                <apexchart
                  type="bar"
                  height="250"
                  :options="dashboardData.chart.options"
                  :series="dashboardData.chart.series"
                  :key="dashboardData.chart.key"
                ></apexchart>
              </div>
            </div>
            <div class="card-footer tx-11 tx-color-03 d-flex">
              <div>
                Хамрах хугацаа:
                {{
                  dashboardData.data.processed.startDate | moment("YYYY.MM.DD")
                }}
                -
                {{ dashboardData.data.processed.endDate | moment("YYYY.MM.DD")
                }}<br />
                Боловсруулсан:
                {{ dashboardData.data.processed.time.toFixed(2) }}сек
              </div>
              <a @click="$router.push({name: 'penaltyreportHours'})" class="btn btn-secondary mg-l-auto">
                  Тайлан
                </a>
              <div class="mg-l-auto">
                <a @click="filterDateObj.mdl= true;" class="btn btn-primary">
                  <feather type="filter"></feather>
                  Огноо
                </a>
              </div>
            </div>
          </div>
      </div>
    </div>

    
    <filter-date @do-search="doSearch" :mdl="filterDateObj.mdl" @on-hide="filterDateObj.mdl= false"></filter-date>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import VueApexCharts from "vue-apexcharts";

import { request } from "@/api/all";
const moment = require("moment");

export default {
  components: {
    apexchart: VueApexCharts,
    filterDate: () => ({
      component: import("@/views/apps/penalty/components/filterDate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      filterDateObj: {
        mdl: false,
        d1: null,
        d2: null
      },

      dashboardData: {
        chart: {
          key: 0,
          series: [
            {
              name: "%",
              data: [],
            },
          ],
          options: {
            chart: {
              height: 150,
              type: "line",
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "straight",
            },
            grid: {
              row: {
                colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                opacity: 0.5,
              },
            },
            xaxis: {
              categories: [],
            },
          },
        },
        rdy: false,
        params: {
          mode: 2,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          list: [],
        },
      },
    };
  },
  mounted() {
    this.loadVehicle();
  },
  methods: {
    doSearch(e){
      this.dashboardData.params.startDate= e.d1;
      this.dashboardData.params.endDate= e.d2;
      this.dashboardData.params.mode= 0;
      this.loadVehicle();
    },

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    // getUniqueValues(array, key) {
    //   var result = new Set();
    //   array.forEach(function(item) {
    //     if (item.hasOwnProperty(key)) {
    //       result.add(item[key]);
    //     }
    //   });
    //   return result;
    // },
    loadVehicle() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/VehicleCountByHour" },
        params: {
          mode: this.dashboardData.params.mode,
          startDate: this.dashboardData.params.startDate,
          endDate: this.dashboardData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.dashboardData.data=res.data;
          this.dashboardData.chart.series[0].data = this.dashboardData.data.list.map((x) => {
            return x.count;
          });
          this.dashboardData.chart.options.xaxis.categories = this.dashboardData.data.list.map((x) => {
            return x.hour;
          });
          this.dashboardData.chart.key++;
          this.dashboardData.rdy = true;
          // this.list = res.data.list;
          // var cmrs = this.getUniqueValues(res.data.list, "cameraName");
          // //console.log('res', res, cmrs);
          // this.cameras = cmrs;
        }
      });

    }
  },
};
</script>

<style></style>
